export default __webpack_public_path__ + "images/SpeakersPhotos/José-López_Igeneris.jpg?8fec71f1";